import { render, staticRenderFns } from "./appointment-icon.vue?vue&type=template&id=5d807946"
import script from "./appointment-icon.vue?vue&type=script&lang=js"
export * from "./appointment-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports